if (!customElements.get('ee-japan-plan-comparison')) {
  customElements.define('ee-japan-plan-comparison', class extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.data = JSON.parse(this.querySelector('[data-plan-comparison]').textContent);
      this.root = this.closest('product-info');
      if (!this.root || !this.dialog.showModal) return;
      this.handleSubmit = this.intercept.bind(this);
      this.handleClose = () => {
        this.track('japan_plan_dismiss', this.context(), {dismiss_reason: 'close'});
        this.dialog.close();
      };
      this.handleCancel = () => this.track('japan_plan_dismiss', this.context(), {dismiss_reason: 'escape'});
      this.handleDetails = () => this.track('japan_plan_details', this.context());
      this.handleKeep = () => {
        const form = document.getElementById(this.dataset.formId);
        if (!form || form.elements.namedItem('id').value !== this.currentId) {
          this.dialog.close();
          return;
        }
        const submitter = form.querySelector('[name="add"]');
        if (!submitter || submitter.disabled || submitter.getAttribute('aria-disabled') === 'true') return;
        const selection = this.context('original');
        this.track('japan_plan_keep', selection);
        this.pendingOriginal = selection;
        this.setDecision(form, selection);
        this.dialog.close();
        this.approved = true;
        try { form.requestSubmit(submitter); } finally {
          this.approved = false;
          this.clearDecision(form);
        }
      };
      this.handleUpgrade = () => {
        this.track('japan_plan_select_upgrade', this.context('upgraded'));
        this.showArrival();
      };
      this.handleBack = () => {
        const quantityInput = this.querySelector('[data-upgrade-form] [name="quantity"]');
        if (quantityInput.validity.valid) this.quantity = Number(quantityInput.value);
        this.showComparison();
        this.querySelector('[data-upgrade]').focus();
      };
      this.handleUpgradeAdded = async event => {
        if (!this.upgradeSubmitting || event.target !== this.querySelector('[data-upgrade-form]').closest('product-form') || String(event.detail.variantId) !== this.pendingUpgrade?.to.id) return;
        this.upgradeSubmitting = false;
        const upgrade = this.pendingUpgrade;
        this.pendingUpgrade = null;
        this.trackUpgrade(upgrade, event.detail);
        const cartUrl = window.routes?.cart_url || '/cart';
        const coupon = upgrade?.to.discount > 0 && Date.now() <= Date.parse(this.dataset.saleEnd) ? upgrade.to.coupon : '';
        const discountUrl = new URL((window.Shopify?.routes?.root || '/') + 'discount/' + encodeURIComponent(coupon), window.location.origin);
        discountUrl.searchParams.set('redirect', cartUrl);
        if (coupon) {
          try {
            const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/update.js', {
              method: 'POST',
              headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
              body: JSON.stringify({discount: coupon})
            });
            if (!response.ok) throw new Error('Discount update failed');
            await response.json();
          } catch (error) {
            window.location.assign(discountUrl.toString());
            return;
          }
        }
        window.location.assign(cartUrl);
      };
      this.handleOriginalAdded = event => {
        const selection = this.pendingOriginal;
        const form = document.getElementById(this.dataset.formId);
        if (!selection || event.target !== form?.closest('product-form') || String(event.detail.variantId) !== selection.from.id) return;
        this.pendingOriginal = null;
        this.track('japan_plan_original_added', selection, {upgrade_stage: 'add_to_cart'}, event.detail);
      };
      this.handleAddFailed = event => {
        const upgradeForm = this.querySelector('[data-upgrade-form]').closest('product-form');
        const originalForm = document.getElementById(this.dataset.formId)?.closest('product-form');
        const upgrading = event.target === upgradeForm && this.upgradeSubmitting && String(event.detail.variantId) === this.pendingUpgrade?.to.id;
        const keeping = event.target === originalForm && String(event.detail.variantId) === this.pendingOriginal?.from.id;
        if (!upgrading && !keeping) return;
        const selection = upgrading ? this.pendingUpgrade : this.pendingOriginal;
        if (upgrading) {
          this.upgradeSubmitting = false;
          this.pendingUpgrade = null;
        } else this.pendingOriginal = null;
        this.track('japan_plan_add_failed', selection, {error_code: event.detail.code === 'INVALID' ? 'cart_rejected' : 'network'});
      };
      this.addEventListener('ee:product-added', this.handleUpgradeAdded);
      this.root.addEventListener('ee:product-added', this.handleOriginalAdded);
      this.root.addEventListener('ee:product-add-failed', this.handleAddFailed);
      this.handleBackdrop = event => {
        if (event.target !== this.dialog) return;
        const bounds = this.dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) {
          this.track('japan_plan_dismiss', this.context(), {dismiss_reason: 'backdrop'});
          this.dialog.close();
        }
      };
      this.root.addEventListener('submit', this.handleSubmit, true);
      this.querySelector('[data-close]').addEventListener('click', this.handleClose);
      this.querySelector('[data-keep]').addEventListener('click', this.handleKeep);
      this.querySelector('[data-upgrade]').addEventListener('click', this.handleUpgrade);
      this.querySelector('[data-back]').addEventListener('click', this.handleBack);
      this.dialog.addEventListener('click', this.handleBackdrop);
      this.dialog.addEventListener('cancel', this.handleCancel);
      this.querySelector('[data-faster-link]').addEventListener('click', this.handleDetails);
    }
    disconnectedCallback() {
      this.root?.removeEventListener('submit', this.handleSubmit, true);
      this.root?.removeEventListener('ee:product-added', this.handleOriginalAdded);
      this.root?.removeEventListener('ee:product-add-failed', this.handleAddFailed);
      this.querySelector('[data-close]')?.removeEventListener('click', this.handleClose);
      this.querySelector('[data-keep]')?.removeEventListener('click', this.handleKeep);
      this.querySelector('[data-upgrade]')?.removeEventListener('click', this.handleUpgrade);
      this.querySelector('[data-back]')?.removeEventListener('click', this.handleBack);
      this.removeEventListener('ee:product-added', this.handleUpgradeAdded);
      this.dialog?.removeEventListener('click', this.handleBackdrop);
      this.dialog?.removeEventListener('cancel', this.handleCancel);
      this.querySelector('[data-faster-link]')?.removeEventListener('click', this.handleDetails);
      if (this.dialog?.open) this.dialog.close();
    }
    static findMatch(current, variants) {
      if (!current?.unlimited || current.days < 1 || current.days > 30) return null;
      return variants.filter(variant => variant.available && variant.days >= current.days && variant.hotspot)
        .sort((a, b) => a.days - b.days || a.amount - b.amount)[0] || null;
    }
    showComparison() {
      this.querySelector('[data-comparison-view]').hidden = false;
      this.querySelector('[data-arrival-view]').hidden = true;
      this.querySelector('h2').textContent = this.dataset.title;
      this.querySelector('.ee-japan-compare__intro').textContent = '';
      this.querySelector('.ee-japan-compare__intro').hidden = true;
    }
    showArrival() {
      const form = this.querySelector('[data-upgrade-form]');
      form.elements.namedItem('id').value = this.fasterId;
      form.elements.namedItem('quantity').value = this.quantity;
      const dateInput = this.querySelector('[data-upgrade-date]');
      const today = new Date();
      const latest = new Date(today);
      latest.setDate(latest.getDate() + 179);
      const dateValue = date => [date.getFullYear(), String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0')].join('-');
      dateInput.min = dateValue(today);
      dateInput.max = dateValue(latest);
      if (!dateInput.value || dateInput.value < dateInput.min || dateInput.value > dateInput.max) dateInput.value = dateInput.min;
      this.querySelector('[data-comparison-view]').hidden = true;
      this.querySelector('[data-arrival-view]').hidden = false;
      this.querySelector('h2').textContent = this.dataset.arrivalTitle;
      this.querySelector('.ee-japan-compare__intro').textContent = '';
      this.querySelector('.ee-japan-compare__intro').hidden = true;
      dateInput.focus();
    }
    prepareUpgrade(event) {
      const form = event.target;
      if (this.upgradeSubmitting) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
      if (!form.reportValidity()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
      if (event.submitter?.getAttribute('aria-disabled') === 'true') return;
      const parts = this.querySelector('[data-upgrade-date]').value.split('-').map(Number);
      form.elements.namedItem('properties[Arrival Date]').value = new Date(parts[0], parts[1] - 1, parts[2]).toLocaleDateString('en-GB', {day: 'numeric', month: 'long', year: 'numeric'});
      this.pendingUpgrade = this.context('upgraded');
      this.pendingUpgrade.quantity = Number(form.elements.namedItem('quantity').value);
      this.setDecision(form, this.pendingUpgrade);
      this.track('japan_plan_upgrade_attempt', this.pendingUpgrade);
      this.upgradeSubmitting = true;
    }
    context(choice = 'undecided') {
      return {
        from: this.data.current.find(variant => variant.id === this.currentId),
        to: this.data.faster.find(variant => variant.id === this.fasterId),
        quantity: this.quantity,
        choice
      };
    }
    clearDecision(form) {
      form.querySelectorAll('[data-japan-decision]').forEach(input => input.remove());
    }
    setDecision(form, selection) {
      this.clearDecision(form);
      const properties = {
        _ee_japan_choice: selection.choice,
        _ee_japan_from_variant: selection.from.id,
        _ee_japan_to_variant: selection.to.id,
        _ee_japan_from_days: selection.from.days,
        _ee_japan_to_days: selection.to.days
      };
      try {
        if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed()) {
        const cookie = document.cookie.split('; ').find(value => value.startsWith('_ga='))?.slice(4);
        const client = /^GA\d+\.\d+\.(\d+\.\d+)$/.exec(cookie || '')?.[1];
        if (client) properties._ee_japan_ga_client = client;
        }
      } catch (_) {}
      Object.entries(properties).forEach(([key, value]) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[' + key + ']';
        input.value = String(value);
        input.dataset.japanDecision = '';
        form.appendChild(input);
      });
    }
    trackUpgrade(upgrade, result) {
      this.track('japan_plan_upgrade', upgrade, {upgrade_stage: 'add_to_cart'}, result);
    }
    track(name, selection, extra = {}, result) {
      try {
        const privacy = window.Shopify?.customerPrivacy;
        if (!selection?.from || !selection?.to || !privacy?.analyticsProcessingAllowed() || typeof window.Shopify?.analytics?.publish !== 'function') return;
        const chosen = selection.choice === 'original' ? selection.from : selection.to;
        const unitPrice = Number(result?.item?.final_price ?? result?.item?.price ?? chosen.amount) / 100;
        const parameters = {
          japan_plan_choice: selection.choice,
          from_product: 'japan-esim',
          to_product: 'japan-unlimited-esim',
          from_variant_id: selection.from.id,
          to_variant_id: selection.to.id,
          from_days: selection.from.days,
          to_days: selection.to.days,
          quantity: selection.quantity,
          currency: this.dataset.currency,
          ...extra
        };
        if (result && Number.isFinite(unitPrice)) {
          parameters.value = Math.round(unitPrice * selection.quantity * 100) / 100;
          parameters.items = [{
            item_id: chosen.id,
            item_name: selection.choice === 'original' ? 'Japan eSIM' : 'Japan Unlimited Data eSIM',
            item_variant: String(chosen.days) + ' days',
            quantity: selection.quantity,
            price: unitPrice,
            japan_plan_choice: selection.choice
          }];
        }
        if (this.dataset.preview === 'true') parameters.debug_mode = true;
        Promise.resolve(window.Shopify.analytics.publish('ee:' + name, parameters)).catch(() => {});
      } catch (error) {
        console.warn('Japan plan analytics unavailable');
      }
    }
    intercept(event) {
      if (event.target.matches('[data-upgrade-form]')) {
        this.prepareUpgrade(event);
        return;
      }
      if (this.approved || event.defaultPrevented || event.target.getAttribute('id') !== this.dataset.formId) return;
      if (event.submitter && event.submitter.name !== 'add') return;
      if (event.submitter?.disabled || event.submitter?.getAttribute('aria-disabled') === 'true') return;
      const current = this.data.current.find(variant => variant.id === event.target.elements.namedItem('id').value);
      const faster = this.constructor.findMatch(current, this.data.faster);
      this.clearDecision(event.target);
      if (!faster) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      this.currentId = current.id;
      this.fasterId = faster.id;
      this.quantity = Math.max(1, Number(event.target.elements.namedItem('quantity')?.value) || 1);
      this.showComparison();
      this.querySelector('[data-current-days]').textContent = current.days + ' ' + (current.days === 1 ? this.dataset.dayLabel : this.dataset.daysLabel);
      this.querySelector('[data-faster-days]').textContent = faster.days + ' ' + (faster.days === 1 ? this.dataset.dayLabel : this.dataset.daysLabel);
      this.querySelector('[data-faster-hotspot]').textContent = faster.hotspot;
      this.querySelector('[data-current-price]').textContent = current.price;
      const onSale = faster.discount > 0 && Date.now() <= Date.parse(this.dataset.saleEnd);
      this.querySelector('[data-faster-price]').textContent = onSale ? faster.salePrice : faster.price;
      const original = this.querySelector('[data-faster-original]');
      original.textContent = faster.price;
      original.hidden = !onSale;
      this.querySelector('[data-coupon]').hidden = !onSale;
      this.querySelector('[data-coupon-value]').textContent = faster.coupon;
      const url = new URL(this.dataset.productUrl, window.location.origin);
      url.searchParams.set('variant', faster.id);
      const preview = new URL(window.location.href).searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      this.querySelector('[data-faster-link]').href = url.toString();
      if (!this.dialog.open) {
        this.dialog.showModal();
        this.track('japan_plan_offer', this.context());
      }
    }
  });
}
